import { render, staticRenderFns } from "./PartnerModal.vue?vue&type=template&id=63b54f8c&scoped=true"
import script from "./PartnerModal.vue?vue&type=script&lang=js"
export * from "./PartnerModal.vue?vue&type=script&lang=js"
import style0 from "./PartnerModal.vue?vue&type=style&index=0&id=63b54f8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b54f8c",
  null
  
)

export default component.exports